import 'app.vue.components.basket.mixin';
let BasketAdd = BX.App.Vue.Mixins.BasketAdd;

export const VoblerForm = {
    mixins: [BasketAdd],
    inject: ['propses', 'offers'],
    data() {
        return {
            SelectSizeCode: false,
            SelecOfferId: 0
        };
    },
    computed: {
        sizes() {
            let sizes = [];
            if (this.propses.SIZE?.VALUES) {
                for (let i in this.propses.SIZE.VALUES) {
                    if (!this.propses.SIZE.VALUES[i].NA) sizes.push(this.propses.SIZE.VALUES[i]);
                }
            }
            return sizes;
        },
        mapColor() {
            let map = [];
            if (this.propses.COLOR?.VALUES) {
                for (let i in this.propses.COLOR.VALUES) {
                    if (this.propses.COLOR.VALUES[i].XML_ID) {
                        map[this.propses.COLOR.VALUES[i].XML_ID] = i;
                    }
                }
            }
            return map;
        },
        showOffers() {
            let offers = [];
            for (let i in this.offers) {
                if (this.offers[i].PROPERTIES_VALUE.SIZE == this.SelectSizeCode) offers.push(this.offers[i]);
            }
            return offers;
        },
        GoodPrice() {
            let MinPrice = false;
            let MaxPrice = false;
            for (let i in this.offers) {
                let CurPrice = this.offers[i].PRICE;
                if (CurPrice?.PRICE) {
                    if (MinPrice == false || MinPrice.PRICE > CurPrice.PRICE) MinPrice = CurPrice;
                    if (MaxPrice == false || MaxPrice.PRICE < CurPrice.PRICE) MaxPrice = CurPrice;
                }
            }

            if (MinPrice && MaxPrice) {
                if (MinPrice.PRICE == MaxPrice.PRICE) {
                    return MinPrice.PRINT_PRICE;
                } else {
                    return 'от ' + MinPrice.PRINT_PRICE;
                }
            }
            return '<a class="card-item__price" href="https://wa.me/+77055429835" target="_blank">Уточнить цену</a>';
        },
        Price() {
            if (this.Sum) {
                return BX.Currency.currencyFormat(this.Sum, 'KZT', true);
            } else {
                return this.GoodPrice;
            }
        },
        Cnt() {
            let Cnt = 0;
            for (let i in this.form.offers) {
                Cnt = Cnt + this.form.offers[i];
            }
            return Cnt;
        },
        Sum() {
            let Sum = 0;
            for (let i in this.offers) {
                let offer = this.offers[i];
                if (this.form.offers[offer.ID] && offer.PRICE?.PRICE) {
                    Sum = Sum + this.form.offers[offer.ID] * offer.PRICE.PRICE;
                }
            }
            return Sum;
        },
        kaspiUrl() {
            const selectedOffer = this.offers.find(offer => offer.ID === this.SelecOfferId);
            return selectedOffer ? selectedOffer.KASPI_URL : null;
        }
    },
    created() {
        if (!this.SelectSizeCode && this.sizes.length) {
            this.SelectSizeCode = this.sizes[0].XML_ID;
        }
    },
    methods: {
        setSize(Code) {
            this.SelectSizeCode = Code;
        },
        addToBasket() {
            this.add();
        }
    },
    template: /*vue-html*/ `
    <div class="form p-2">

        <div class="form__group role-size_selector">
            <div class="form__title">Размер:</div>
            <span
                v-for="val in sizes"
                :value="val.XML_ID"
                @click="setSize(val.XML_ID)"
                class="label" :class="{'label--active': val.XML_ID == SelectSizeCode}"
            >
                {{ val.NAME }}
            </span>
        </div>

        <div class="form__group">
            <div class="form__title">Цвет:</div>
            <div class="group-types">
                <div
                    v-for="offer in showOffers"
                    :key="'offer_' + offer.ID"
                    @mouseover="SelecOfferId = offer.ID"
                    class="product-type"
                    :class="{'product-type--no': !offer.CAN_BUY, 'product-type--selected': SelecOfferId == offer.ID}"
                >
                    <div class="product-type__preview">
                        <span v-if="mapColor && offer.PROPERTIES_VALUE.COLOR">{{ propses.COLOR.VALUES[mapColor[offer.PROPERTIES_VALUE.COLOR]].NAME }}</span>
                        <a v-if="offer.PREVIEW_PICTURE?.SRC" :href="offer.PREVIEW_PICTURE.SRC" data-lightbox="data1">
                            <img :src="offer.PREVIEW_PICTURE.SRC" alt="" class="image-preview" loading="lazy"/>
                            <div class="middle">
                                <div class="text"><img src="/local/assets/dist/images/zoom.png"></div>
                            </div>
                        </a>
                        <img v-else src="/local/assets/dist/images/logo.svg" alt="" loading="lazy"/>
                    </div>

                    <div class="product-type__main">
                        <input type="hidden" name="offer.ID" v-model="form.offers[offer.ID]">
                        <div v-if="form.offers[offer.ID] && SelecOfferId != offer.ID" class="product-type__value">{{ form.offers[offer.ID] }}</div>
                        <div class="product-count">
                            <div @click.stop="changeQnt(offer.ID, -1)" class="product-count__btn minus">-</div>
                            <div class="product-count__value">{{ form.offers[offer.ID] ? form.offers[offer.ID] : 0 }}</div>
                            <div @click.stop="changeQnt(offer.ID, 1)" class="product-count__btn plus">+</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="form__group">
            <div class="price-item">
                <div v-html="Price" class="price-item__value"></div>
                <div v-if="Cnt" class="price-item__count">{{ Cnt }} шт.</div>
                <div v-if="Cnt" class="price-item__btn">

                    <button class="button-buy" @click="addToBasket">В корзину</button>
                    <div v-if="kaspiUrl">
                        <a :href="kaspiUrl" target="_blank" class="button-kaspi">Купить на Kaspi</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
    `
};
